import { render } from "./Years.vue?vue&type=template&id=362e0fe5&ts=true"
import script from "./Years.vue?vue&type=script&lang=ts"
export * from "./Years.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__